export const RecaptchaSiteKey='6Ld_BKYaAAAAAFuzUQdzSoF8rlCbt6_XhrDpUEcc';
export const RecaptchaSecret='6Ld_BKYaAAAAAMX6px6DiiCTZZRgaaNAlV8dfeVO';
